export enum OrderBy {
  DESC = 'desc',
  ASC = 'asc',
}


export enum ModelEditorStep {
Info = 'info',
AiEngineConfigStep = 'aiEngineConfigStep'

}

export enum ExternalLinkType {
None = '',
FavIcon = 'FavIcon',
Logo = "Logo",
SupportingImage = "SupportingImage",
SupportingVideo = "SupportingVideo",
LinkedIn = "LinkedIn",
Facebook = "Facebook",
Twitter = "Twitter",
// YouTube = "YouTube",
Other = "Other"
}

export enum MatricsType {
Other = '',
AUC = "AUC",
Accuracy = "Accuracy",
Recall = "Recall",
Precision = "Precision",
F1Score = "F1Score",
R2 = "R2",
DunnIndex = "DunnIndex",
BLEUScore = "BLEUScore",
}


export enum InferenceEngineFileTypes {
  SourceFile = "SourceFile",
  PackageDefinitionFile = "PackageDefinitionFile",
  ModelFiles = "ModelFiles",
  PlatformFile = "PlatformFile"
}

export enum InferenceStatus {
  Processing = "Processing",
  Completed = "Completed",
  Error = "Error"
}

export enum InterfaceTypes {
  Chatbot = "Chatbot",
  Form = "Form"
}